export default __webpack_public_path__ + "static/engineering capital-e6507fec9d7f4b5face7e9a5a9efa49e.png";